/**
 * Chrome shared by the two dropdowns under the search field. They are alternate contents of one
 * surface, so the panel and its section labels are described once rather than kept in step by hand.
 */

/** The panel alone, for a dropdown that lays out its own scrolling region and padding. */
export const dropdownFrameClassName =
  'absolute inset-x-0 top-full z-20 mt-px flex max-h-[420px] flex-col rounded-lg border border-brand-neutral-200 bg-white shadow-menu'

export const dropdownSurfaceClassName = `${dropdownFrameClassName} overflow-y-auto p-2`

export const dropdownSectionHeaderClassName = 'text-xs font-medium uppercase leading-4 tracking-wide text-brand-neutral-600'
